import { render, staticRenderFns } from "./FileFormView.vue?vue&type=template&id=4ec5266a&"
import script from "./FileFormView.vue?vue&type=script&lang=js&"
export * from "./FileFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ec5266a')) {
      api.createRecord('4ec5266a', component.options)
    } else {
      api.reload('4ec5266a', component.options)
    }
    module.hot.accept("./FileFormView.vue?vue&type=template&id=4ec5266a&", function () {
      api.rerender('4ec5266a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/documentManagement/vistas/modals/FileFormView.vue"
export default component.exports